export default () => {
  const injuryOccurredTrue = $("#incident_report_injury_occurred_true");
  const injuryOccurredFalse = $("#incident_report_injury_occurred_false");
  const natureOfInjury = $("#incident_report_nature_of_injury");

  function setNatureOfInjuryState(isDisabled) {
    natureOfInjury.prop("disabled", isDisabled);
    if (isDisabled) {
      natureOfInjury.val("");
    }
  }

  const isTrueChecked = injuryOccurredTrue.is(":checked");
  setNatureOfInjuryState(!isTrueChecked);

  injuryOccurredTrue.on("change", function () {
    setNatureOfInjuryState(!this.checked);
  });

  injuryOccurredFalse.on("change", function () {
    setNatureOfInjuryState(this.checked);
  });
};
